// @flow

import * as React from 'react';

type ReactRefProp<Instance> = {current: Instance | null} | ((Instance | null) => mixed);
type UseEffectReturn = () => void;

const useOnClickOutside = (ref: ReactRefProp<any>, handler: (event: Event) => void) => {
    React.useEffect(
        (): UseEffectReturn => {
            const listener = (event: Event) => {
                if (!ref.current || (ref.current: any).contains(event.target)) {
                    return;
                }

                handler(event);
            };
            document.addEventListener('mousedown', listener);
            document.addEventListener('touchstart', listener);

            return () => {
                document.removeEventListener('mousedown', listener);
                document.removeEventListener('touchstart', listener);
            };
        },
        [ref, handler]
    );
};

export default useOnClickOutside;
